// extracted by mini-css-extract-plugin
export default {"cls1":"VeloFab-MobileFab_cls1__F2bHL","cls2":"VeloFab-MobileFab_cls2__VRBRa VeloFab-MobileFab_cls1__F2bHL"};